module.exports = __webpack_public_path__ + "img/Angiogenesis-GBM_10X_TPCP.665857fb.png";